export default __webpack_public_path__ + "static/media/ic-person.2f56a84b.svg";